var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select2',_vm._l((_vm.datos),function(data){return _c('option',{domProps:{"value":data}},[_vm._v("\n\t\t"+_vm._s(data)+"\n\t")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }